// ./src/contexts/ThemeContext/ThemeContext.tsx
import React from "react";
import { MantineProvider } from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import { ModalsProvider } from "@mantine/modals";
import { formSubmitsTheme } from "../../styles/theme";
import { GlobalStyles } from "../../styles/GlobalStyles";

interface ThemeProviderProps {
  children: React.ReactNode;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  return (
    <MantineProvider theme={formSubmitsTheme}>
      <GlobalStyles />
      <Notifications />
      <ModalsProvider>{children}</ModalsProvider>
    </MantineProvider>
  );
};
